// extracted by mini-css-extract-plugin
export default {"pageContainer":"NotFound_pageContainer__y+GZ9"};